import { SET_CUSTOMER } from './actionTypes'
import { CustomerActionTypes } from './types' 

const initialState = {
    firstName: "",
    lastName: "",
    email: "",
    mobile: "",
    terms: false,
    marketing: false, 
    planOnReplacing: 0, 
    interestedNext: "", 
    dealerBranch: ""
}

export default (state = initialState, action: CustomerActionTypes) => {
  switch (action.type) {
    case SET_CUSTOMER:
      return { ...state, ...action.payload }
    default: 
      return state
  }
}
